__turbopack_context__.v({
  "className": "montserrat_5791600e-module__9RF4iq__className",
});
